export function compressionByField(field, fallback, desc) {
    return (a, b) => {
        const [av, bv] = [a[field], b[field]];
        if (av == null && bv == null) {
            return fallback?.(a, b) ?? 0;
        }
        if (av == null) {
            return desc ? 1 : -1;
        }
        if (bv == null) {
            return desc ? -1 : +1;
        }
        if (av < bv) {
            return desc ? 1 : -1;
        }
        if (av > bv) {
            return desc ? -1 : +1;
        }
        return fallback?.(a, b) ?? 0;
    };
}
